module.exports = __webpack_public_path__ + "static/media/campervan.86393359.svg";